var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-onlyoffice"},[_c('div',{attrs:{"id":_vm.id}}),(_vm.showLogo)?_c('div',{staticClass:"cube-onlyoffice-logo"},[_vm._v("OFFICE")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }